/*
 * File: /src/stores/shop-customobjects-manage.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Friday, 17th August 2018 2:46:32 pm
 * Last Modified: Friday, 24th August 2018 1:15:35 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
import { StoreDefaultSchemaHelper } from '@/helpers'

const initialState = () => ({
    scope: 'customobjectsgroups',
    id: null,
    label: null,
    customObjects: {
        objects: [],
        usedKeys: []
    }
})

const state = StoreDefaultSchemaHelper.buildState({
    state: initialState()
})

const actions = StoreDefaultSchemaHelper.buildActions({
    actions: {
        async SAVE_CUSTOM_OBJECT({ state, commit, dispatch }) {
            let customObjectGroup = state.schemaData.metafield
            let value = JSON.parse(customObjectGroup.value)
            value.customObjects = state.customObjects
            customObjectGroup.value = value

            let params = {
                endpoint: `customobjectsgroups`,
                method: 'POST',
                data: { customObjectGroup, returnSelf: true }
            }

            try {
                const { metafield } = await dispatch('shopifyApi/REQUEST', params, { root: true })

                if (metafield) {
                    if (metafield) {
                        commit('SET_SCHEMA_METAFIELD', { metafield })
                        commit('SET_SCHEMA_FROM_METAFIELD', { metafield })
                        commit('SET_CUSTOM_OBJECTS_FROM_METAFIELD', { metafield })
                        return metafield
                    }
                }
            } catch (error) {
                console.error(`SAVE_CUSTOM_OBJECT_GROUP`, error)
                throw error
            }
        }
    }
})

const mutations = StoreDefaultSchemaHelper.buildMutations({
    mutations: {
        SET_ID(state, { id }) {
            state.id = id
        },

        SET_SCHEMA_FROM_METAFIELD(state, { metafield }) {
            if (metafield.value && metafield.value !== '') {
                let value = JSON.parse(metafield.value)

                if (value && value.schema) {
                    state.schemaData.schema = value.schema
                } else {
                    state.schemaData.schema = {
                        fields: [],
                        usedKeys: []
                    }
                }
            }
        },

        SET_CUSTOM_OBJECTS_FROM_METAFIELD(state, { metafield }) {
            if (metafield.value && metafield.value !== '') {
                let value = JSON.parse(metafield.value)

                if (value && value.customObjects) {
                    state.customObjects = value.customObjects
                } else {
                    state.customObjects = {
                        objects: [],
                        usedKeys: []
                    }
                }
            }
        },

        ADD_CUSTOM_OBJECT(state, { customObject }) {
            state.customObjects.objects.push(customObject)
            state.customObjects.usedKeys.push(customObject.key)
        },

        REMOVE_CUSTOM_OBJECT(state, { key }) {
            let coIndex = state.customObjects.objects.findIndex(item => item.key === key)
            let keyIndex = state.customObjects.usedKeys.findIndex(item => item === key)
            state.customObjects.objects.splice(coIndex, 1)
            state.customObjects.usedKeys.splice(keyIndex, 1)
        }
    }
})

const getters = StoreDefaultSchemaHelper.buildGetters({
    getters: {
        id: state => state.id,
        customObjectsMapped: state => {
            if (!state.customObjects) {
                return null
            }

            return state.customObjects.objects.map(item => {
                return {
                    key: item.key,
                    name: item.label,
                    to: { name: 'customobjects.edit', query: { key: item.key, id: state.id } },
                    icon: 'text-block',
                    editUrl: { name: 'customobjects.edit', query: { key: item.key, id: state.id } },
                    editUrlPlacement: 'outer'
                }
            })
        },
        usedObjectsKeys: state => state.customObjects.usedKeys
    }
})

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/stores/shop-customobjectsgroups-manage.js